import { c as _c } from "react/compiler-runtime";
import { type RefObject } from 'react';
import { Image } from '@/app/components/media/image';
import { generateSources } from '@/app/components/media/image/generate-sources';
import type { ContentHubEntry } from '@/app/components/sections/content-hub/types';
import { YoutubeIframe } from '@/app/components/youtubeIframe';
import { cn } from '@/app/utils/cn';
interface MediaResultProps {
  ref: RefObject<HTMLDivElement | null>;
  item: ContentHubEntry;
  category: string;
  className?: string;
  isPage?: boolean;
}
export const MediaResult = t0 => {
  const $ = _c(15);
  const {
    ref,
    item,
    category,
    className,
    isPage: t1
  } = t0;
  const isPage = t1 === undefined ? false : t1;
  const image = item.thumbnailImage;
  const imageSrc = image?.url ?? "";
  const imageWidth = image?.width || 16;
  const imageHeight = image?.height || 9;
  const t2 = !!item.youtubeId;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("modal-image-wrapper", {
      "calc-ratio": t2
    }, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== category || $[4] !== imageHeight || $[5] !== imageSrc || $[6] !== imageWidth || $[7] !== isPage || $[8] !== item.title || $[9] !== item.youtubeId) {
    t4 = category === "experiences" && !!item.youtubeId ? <YoutubeIframe id={item.youtubeId} autoplay={!isPage} muted={false} className="size-full" /> : <Image src={imageSrc} width={imageWidth} height={imageHeight} alt={item.title} aspectRatio="calculate" className="pointer-events-none" sources={[{
      srcset: imageSrc,
      media: {
        minWidth: 1024
      },
      options: {
        width: 828
      }
    }, ...generateSources("tablet", {
      mobileSrc: imageSrc
    }).slice(1), ...generateSources("mobile", {
      mobileSrc: imageSrc
    })]} loading="eager" placeholder="shimmer" priority={isPage} />;
    $[3] = category;
    $[4] = imageHeight;
    $[5] = imageSrc;
    $[6] = imageWidth;
    $[7] = isPage;
    $[8] = item.title;
    $[9] = item.youtubeId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== ref || $[12] !== t3 || $[13] !== t4) {
    t5 = <div ref={ref} className={t3}>{t4}</div>;
    $[11] = ref;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};